(ns dashboard.components.guide
  (:require
   [reagent.core :as reagent]
   [re-frame.core :as re-frame]
   [clojure.string :refer [split lower-case join]]
   [headlessui-reagent.core :as ui]
   [dashboard.utils :refer [listen cs format-percent href index-by index-of format-day]]
   [dashboard.subs :as subs]
   [dashboard.i18n :refer [tr]]
   [dashboard.events.spaces :as space-events]))


(defn- header-2 [{:keys [id title]}]
  [:h2.w-full.bg-gray-100.px-2.py-2.mb-1
   {:class "-ml-2"
    :id id}
   title])

(defn- toc []
  [:div.mt-2
   [:div.prose.prose-a:text-primary-500.hover:prose-a:text-primary-600.focus:prose-a:outline-none
    [header-2
     {:title "目次"}]
    [:ol
     [:li
      [:a
       {:href "#introduction"}
       "はじめに"]
      [:ul
       [:li
        [:a
         {:href "#introduction-overview"}
         "概要"]]
       [:li
        [:a
         {:href "#introduction-user-guide"}
         "ユーザーガイドの読み方"]]]]
     [:li
      [:a
       {:href "#settings"}
       "設定"]
      [:ul
       [:li
        [:a
         {:href "#settings-access"}
         "アクセス方法"]]
       [:li
        [:a
         {:href "#settings-staff"}
         "社員について"]]
       [:li
        [:a
         {:href "#settings-shift"}
         "シフトについて"]]
       [:li
        [:a
         {:href "#settings-team"}
         "チームについて"]]]]
     [:li
      [:a
       {:href "#schedule"}
       "予定"]
      [:ul
       [:li
        [:a
         {:href "#schedule-creation"}
         "予定を追加する"]]]]
     [:li
      [:a
       {:href "#shift"}
       "シフト"]
      [:ul
       [:li
        [:a
         {:href "#shift-creation"}
         "シフトを作成する"]]]]]]])

(defn- start-page []
  [:div.mt-2
   [:div.flex.justify-end.mb-2
    [:span.font-semibold.pr-2
     "最終変更日: "
     [:time
      {:dateTime "2022-09-01"}
      "2022年9月"]]]
   [:article.prose.prose-a:text-primary-500
    [header-2
     {:id "introduction"
      :title "はじめに"}]
    [:h3#introduction-overview
     "概要"]
    [:p
     "本ツールは、カルティエ ジャパンの全社員が活用するプラットフォームであり、その主な目的は「ブティックのシフトに関わる作業や情報を一元管理する」ことです。"]
    [:h3#introduction-user-guide
     "ユーザーガイドの読み方"]
    [:p "４種類のアカウントは権限内容が異なるため、ご自身に該当するラベルが明記されている箇所をご参照ください。"]
    [:div.grid.grid-cols-2.border.border-black.mb-6.mx-8
     [:div.text-center.bg-primary-500.text-white.p-2.font-semibold
      "シフト作成者"]
     [:div.text-center.bg-black.text-white.p-2.font-semibold
      "シフト閲覧者"]
     [:div.text-center.bg-beige-500.text-white.p-2.font-semibold
      "オフィス"]
     [:div.text-center.bg-yellow-500.text-white.p-2.font-semibold
      "オフィス（管理者）"]]]])

(defn- settings-page []
  [:div.mt-2
   [:article.prose.prose-a:text-primary-500
    [header-2
     {:id "settings"
      :title "設定"}]
    [:h3#settings-access
     "アクセス方法"]
    [:div.flex.border.border-black.mb-6.w-fit
     [:div.text-center.bg-primary-500.text-white.p-3.font-semibold.text-sm
      "シフト作成者"]
     [:div.text-center.bg-black.text-white.p-3.font-semibold.text-sm
      "シフト閲覧者"]
     [:div.text-center.bg-beige-500.text-white.p-3.font-semibold.text-sm
      "オフィス"]
     [:div.text-center.bg-yellow-500.text-white.p-3.font-semibold.text-sm
      "オフィス（管理者）"]]
    [:p
     "画面右上の丸いアイコンをタップし、設定を選択する"]
    [:h3#settings-staff
     "社員について"]
    [:div.flex.border.border-black.mb-6.w-fit
     [:div.text-center.bg-primary-500.text-white.p-3.font-semibold.text-sm
      "シフト作成者"]]
    [:p "貴店スタッフの編集は「編集」ボタンより、削除は「削除」ボタンからご対応ください。"]
    [:div.flex.border.border-black.mb-6.w-fit
     [:div.text-center.bg-beige-500.text-white.p-3.font-semibold.text-sm
      "オフィス"]
     [:div.text-center.bg-yellow-500.text-white.p-3.font-semibold.text-sm
      "オフィス（管理者）"]]
    [:p "全ブティックの追加、編集、削除が可能で、OMSの入社と異動はマニュアルでの対応が必要となります。記入事項は、既存スタッフの情報を例として参照し、必ずOMSのボタンをON（赤）にして保存ください。"]
    [:h3#settings-shift
     "シフトについて"]
    [:div.flex.border.border-black.mb-6.w-fit
     [:div.text-center.bg-primary-500.text-white.p-3.font-semibold.text-sm
      "シフト作成者"]]
    [:p
     "シフトパターンの設定から、貴店専用のタグやシフト式をカスタマイズいただけます。"]
    [:p
     [:b "シフトパターン："]
     "WIMSで登録済みのシフトのみ、設定の対象となります。１つのWIMSコードに対し、複数のシフトを設定することも可能です。"]
    [:p
     [:b "タグ（任意）："]
     "特定のタスクや外出予定がある場合など、イレギュラーな案件をタグで表記することが可能です。"]
    [:p
     [:b
      "シフト式（任意）："]
     "シフト作成で必要となる指標を設定いただけます（例. 開店時の販売可能スタッフ数）"]
    [:p
     "追加は赤い追加ボタンを選択、既存内容の修正または削除は該当の列より操作ください。"]
    [:p
     [:b
      "注意点①"] " シフトパターンの追加時に表示される「時間」項目ですが、自動記入ではございません。勤務時間はこれをもとに計算されるため、ご自身で必ず正しい値をご記入ください。"]
    [:p
     [:b "注意点②"] " シフトパターンの追加時に表示される「WIMS」項目には、WIMSでの登録が完了しているコードのみをご記入ください。"]
    [:p
     [:b "注意点③"] " 勤務日数から省きたいシフトパターンは、公休のボタンをON（赤）にして保存ください。"]
    [:h3#settings-team
     "チームについて"]
    [:div.flex.border.border-black.mb-6.w-fit
     [:div.text-center.bg-primary-500.text-white.p-3.font-semibold.text-sm
      "シフト作成者"]]
    [:p
     "１人のスタッフに対し、１チームを設定ください。設定内容によってシフト表でのスタッフ並び順が左右されます。追加は赤い追加ボタンを選択し、メンバーを追加する際には下へスクロールで探すか、あるいは以下どちらかの検索方法をご活用ください。"]
    [:ul
     [:li "日本語、あるいはローマ字名を記入して検索する"]
     [:li "右上のフィルターより、タイトル別に検索する"]]]])

(defn- schedule-page []
  [:div.mt-2
   [:article.prose.prose-a:text-primary-500
    [:h2#schedule.w-full.bg-gray-50.px-2.mb-1
     "予定"]
    [:h3#schedule-creation
     "予定を追加する"]
    [:div.flex.border.border-black.mb-6.w-fit
     [:div.text-center.bg-primary-500.text-white.p-3.font-semibold.text-sm
      "シフト作成者"]]
    [:p
     "ストア イベントを必要に応じて追加ください。赤い追加ボタンより、*の必須項目を最低でもご記入いただき、ステータスを「BTQ承認済」に設定してから保存ください。"]
    [:p
     [:b "注意点①"]
     " ステータスが「BTQ承認済」でないと、シフト表内のイベント列に情報が反映されません。"]
    [:div.flex.border.border-black.mb-6.w-fit
     [:div.text-center.bg-beige-500.text-white.p-3.font-semibold.text-sm
      "オフィス"]
     [:div.text-center.bg-yellow-500.text-white.p-3.font-semibold.text-sm
      "オフィス（管理者）"]]
    [:p
     "カンパニー イベントや研修 / ミーティングを、主催者が追加ください。作成時のステータスは、必ず「申請中」にしてください。リテールより承認され次第、担当者よりステータスを「確定」へ変更にします。"]]])

(defn- shift-page []
  [:div.mt-2
   [:article.prose.prose-a:text-primary-500
    [header-2
     {:id "shift"
      :title "シフト"}]
    [:h3#shift-creation
     "シフトを作成する"]
    [:div.flex.border.border-black.mb-6.w-fit
     [:div.text-center.bg-primary-500.text-white.p-3.font-semibold.text-sm
      "シフト作成者"]]
    [:ol
     [:li "枠の左上にある年月を確認し、その右隣に勤務日数日を記入してください。"]
     [:li "セルを選択後、画面右側のシフトパターンをタップして直接選ぶか、お好みでキーボード操作を行ってください。キーボードの場合、セルを選択後、エンターを押し、①か②どちらかで対応してください。"
      [:ul.not-prose.list-none
       [:li
        "①　下向きの矢印ボタンで該当パターンを選び、エンターを押す"]
       [:li
        "②　シフト表記をキーボードでタイプし、エンターを押す（※「休」などの日本語表記は対象外です）"
        "必要に応じて、タグもシフトパターン同様にお選びください。"]]
      [:p.flex.justify-center.not-prose
       [:img.h-24.border
        {:alt "シフト選択"
         :src "img/screenshots/shift_select.jpg"}]]
      [:p
       "なお、全体のバランスを確認されたい場合には、赤い完成ボタンの左側にある「カウント数」をタップして閲覧モードを変更してください。"]
      [:p.flex.justify-center.not-prose
       [:img.h-40.border
        {:alt "カウント数ボタン"
         :src "img/screenshots/count_button.jpg"}]]]
     [:li "完成したら、赤い完成ボタンよりWIMSエクスポートを選択し、WIMSへ抽出されたファイルをそのまま取り込んでください。"
      [:ul.not-prose.list-none
       [:li "※　OMSの列は、抽出時に自動で省かれます"]
       [:li "※　シフト確定後に変更が生じる場合、変更前に一旦現状のシフトをエクスポートしてから編集することで、旧⇔新バージョンを比べることが可能です"]]]]]])

(defn guide [{:keys [state]}]
  [ui/transition
   {:show (:is-open? state)}
   [ui/dialog
    {:open (:is-open? state)
     :as "div"
     :class "relative z-40"
     :on-close #(re-frame/dispatch [:hide-user-guide])}
    [ui/transition-child
     {:enter "ease-out duration-300"
      :enter-from "opacity-0"
      :enter-to "opacity-100"
      :leave "ease-in duration-200"
      :leave-from "opacity-100"
      :leave-to "opacity-0"}
     [ui/dialog-overlay
      {:class "fixed inset-0 bg-gray-500 bg-opacity-25 transition-opacity"}]]

    [:div.fixed.z-70.inset-0.overflow-y-auto.mt-12
     [:div.flex.items-end.justify-center.min-h-screen.pt-4.px-4.pb-20.text-center.sm:block.sm:p-0
      ;; This element is to trick the browser into centering the modal contents.
      [:span.hidden.inline-block.h-screen.align-middle
       {:aria-hidden true}
       "&#8203;"]
      [ui/transition-child
       {:enter "ease-out duration-300"
        :enter-from "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        :enter-to "opacity-100 translate-y-0 sm:scale-100"
        :leave "ease-in duration-200"
        :leave-from "opacity-100 translate-y-0 sm:scale-100"
        :leave-to "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"}
       [ui/dialog-panel
        {:class "relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full sm:p-6"}
        [:div
         [ui/dialog-title
          {:class "text-3xl font-medium leading-6 text-gray-900 mb-4"}
          (tr :user-guide)]
         [:div
          [toc]
          [start-page]
          [settings-page]
          [schedule-page]
          [shift-page]]]]]]]]])
